import { Navigate, Outlet } from 'react-router-dom';

export const ProtectedRoute = ({ token }: { token: string | null }) => {
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    return <Outlet />;
};
